/* eslint-disable react-hooks/exhaustive-deps */
import { IDailyForcaWeatherResponse, IForecaWeatherInfo } from '@common/models';
import { ICity } from '@common/models/CMS';
import Translate from '@service/Translate';
import { getDailyWeatherCondition, getRecentWeatherCondition } from '@utilize/Weather';
import { FC, useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import Button from '../general/form/Button';
import { WeatherForecast, WeatherRecent } from './index';

interface IWeatherProps {
    city?: ICity;
    className?: string;
    daysCount: number;
    loadOf?: 'foreca' | 'mahan';
}

export const Weather: FC<IWeatherProps> = (props) => {
    const { city, daysCount, className, loadOf = "foreca" } = props;
    const { tr } = Translate;
    const [weatherData, setWeatherData] = useState<IDailyForcaWeatherResponse>();
    const [error, setError] = useState<boolean>();

    useEffect(() => {
        getData();
    }, [city?.forecaWeatherId]);

    const getData = () => {
        setError(false);
        if (city?.forecaWeatherId) {
            getRecentWeatherCondition(city.forecaWeatherId)
                .then((dataOfRecentWeather) => {
                    setWeatherData(a => ({ ...a, weatherRecent: dataOfRecentWeather[city.forecaWeatherId as number] }))
                }).catch(() => setError(true));
            getDailyWeatherCondition(city.forecaWeatherId)
                .then((dataOfDailyWeather) => {
                    setWeatherData(a => ({ ...a, dailyWeather: dataOfDailyWeather[city.forecaWeatherId as number] }))
                }).catch(() => setError(true));
        }
    }

    const unLoadedJsx = () => <div className="unloaded">
        <h3 className="text">{tr("rsv_197")}</h3>
        <Button
            className="-refresh-btn"
            text={tr("btn_retry")}
            color="primary"
            variant="outlined"
            height="40px"
            onClick={() => getData()}
        />
    </div>


    return (
        <div className={`weather${className ? " " + className : ""}${error ? " unloaded" : ""}`}>
            {error ?
                unLoadedJsx()
                :
                <>
                    {
                        weatherData?.weatherRecent && weatherData?.dailyWeather?.length ?
                            <WeatherRecent
                                dataSource={weatherData.weatherRecent || {} as IForecaWeatherInfo}
                                loadOf={loadOf}
                                location={city?.name}
                                sunrise={weatherData.dailyWeather[0].sunrise}
                                sunset={weatherData.dailyWeather[0].sunset}
                            />
                            :
                            <section className='loader-container'>
                                <h3 className='text description'>{tr('weather_status') + ' ' + (city?.name || '')}</h3>
                                {renderLoader(1)}
                            </section>
                    }
                    <section className="weather-forecast-container">
                        {
                            weatherData?.dailyWeather ?
                                weatherData?.dailyWeather?.slice(0, daysCount).map(item => <WeatherForecast
                                    dataSource={item}
                                    key={item.date}
                                    loadOf={loadOf}
                                />)
                                :
                                renderLoader(daysCount)
                        }
                    </section>
                </>}
        </div>
    )

}

export const renderLoader = (numberOfElement: number) => {
    const elements: JSX.Element[] = []
    for (let r = 0; r < numberOfElement; r++)
        elements.push(
            <section key={r} className={`loader${numberOfElement === 1 ? " ones" : ""}`}>
                <ContentLoader width="100%"
                    height="100%"
                    speed={1.4}
                    backgroundColor="#8686866e"
                    foregroundColor="#ffffff3d"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
                </ContentLoader>
            </section>
        )
    return elements
}